import { render, staticRenderFns } from "./AssignServicesToAdminsView.vue?vue&type=template&id=4da0194f&"
import script from "./AssignServicesToAdminsView.vue?vue&type=script&lang=ts&"
export * from "./AssignServicesToAdminsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports